"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Check if we can regenerate edited image from the source image.
 * An image can't regenerate result when there is CORS issue of the source content.
 * @param img The image element to test
 * @returns True when we can regenerate the edited image, otherwise false
 */
function canRegenerateImage(img) {
    if (!img) {
        return false;
    }
    try {
        var canvas = img.ownerDocument.createElement('canvas');
        canvas.width = 10;
        canvas.height = 10;
        var context = canvas.getContext('2d');
        context.drawImage(img, 0, 0);
        context.getImageData(0, 0, 1, 1);
        return true;
    }
    catch (_a) {
        return false;
    }
}
exports.default = canRegenerateImage;
//# sourceMappingURL=canRegenerateImage.js.map